import React from 'react'
import JotformEmbed from 'react-jotform-embed';
import {Container, Typography, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import './../App.css';

const useStyles = makeStyles(theme => ({
    pagetitle:{
     fontFamily:'Poppins',
     paddingTop:'30px',
     fontSize: '50px'
    }
}));

function Contactform() {
    const classes = useStyles();

    return (
      <div>
      <Container maxWidth="sm" component="main" className={classes.heroContent}>
        <Typography component="h1" variant="h2" align="center"className={classes.pagetitle} gutterBottom>
          CONTACT FORM
        </Typography>       
      </Container>
      <Grid container>
         <JotformEmbed src="https://form.jotform.com/200904469265963" />
      </Grid>
      <div style={{marginBottom: '50px'}}></div>            
      </div>
    )
}
export default Contactform